export default {
  connection: {
    host: process.env.VUE_APP_MQTT_HOST,
    port: process.env.VUE_APP_MQTT_PORT,
    endpoint: process.env.VUE_APP_MQTT_ENDPOINT,
    clean: true, // 保留会话
    connectTimeout: 4000, // 超时时间
    reconnectPeriod: 4000, // 重连时间间隔
    // 认证信息
    clientId: 'ant_web_' + new Date().getTime(),
    username: process.env.VUE_APP_MQTT_USERNAME,
    password: process.env.VUE_APP_MQTT_PASSWORD,
  },
};
